import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { shouldEnableNewWeekView } from '../../utils/newWeekViewFeatureFlags';
import OperationHoursTab from './OperationHoursTab';
import OperationHoursTabOld from './OperationHoursTabOld';

/**
 * Wrapper component that conditionally renders OperationHoursTab or OperationHoursTabOld
 * based on the newWeekView feature flag.
 *
 * - When newWeekView is enabled: renders the new OperationHoursTab (stage version)
 * - When newWeekView is disabled: renders OperationHoursTabOld (master version)
 */
const OperationHoursTabWrapper: React.FC = () => {
  const { newWeekViewFlags } = useFlags();
  const state = useSelector((state: RootStateOrAny) => state);

  const isNewWeekViewEnabled = shouldEnableNewWeekView(state, newWeekViewFlags);

  if (isNewWeekViewEnabled) {
    return <OperationHoursTab />;
  }

  return <OperationHoursTabOld />;
};

export default OperationHoursTabWrapper;
